module.exports = __webpack_public_path__ + "img/spotted-orange-lily.9ec8a458.jpg";